import React, { Component } from 'react';
import { Layout, Row } from 'antd';
import { find, propEq } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { getProjects } from 'actions/asyncActions';
import BackButton from 'components/common/elements/BackButton';
import ProjectForm from './ProjectForm';
import Breakpoint from 'components/layout/Breakpoint.js';

@withAsyncActions({
    getProjects,
}, { dispatchOnMount: true, resetOnMount: true })
export default class ProjectEdit extends Component {
    render() {
        const { id } = this.props.match.params;
        const { data } = this.props.getProjects;

        const project = find(propEq('id', Number(id)), data.projects || []);

        return (
            <Layout className="project container page page-sm-no-m main-content">
                <Breakpoint min="sm">
                    <Row type="flex" align="middle" className="m-b-30">
                        <BackButton />
                        {project && <span className="title-route m-l-30">
                            Проект: {project.name}
                        </span>}
                    </Row>
                </Breakpoint>
                <Breakpoint max="sm">
                    <Row className="m-b-30 m-l-20">
                        <BackButton />
                        {project && <div className="title-route m-t-10 m-t-30">
                            Проект: {project.name}
                        </div>}
                    </Row>
                </Breakpoint>
                {project && <ProjectForm
                    isEdit={true}
                    initialValues={project}
                    history={this.props.history}
                />}
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/project/ProjectEdit.js